import {
  Box
} from "@chakra-ui/react";

import type { ReactNode } from "react";

import { NavBar } from "~/components"
import type { User } from "~/types";
import { NavBarBeneficiario } from "./nav-bar-beneficiario";
import { NavBarEmpty } from "./nav-bar-empty";
import { NavBarCaa } from "./nav-bar-caa";
import { NavBarAT } from "./nav-bar-at";
import SiarcFooter from "./footer"

interface LayoutBaseProps {
  LeftElement?: ReactNode,
  RightElement?: ReactNode,
  children?: ReactNode,
  user? : User,
  latestDocPrivacy : string
}


export let LayoutBase: React.FC<LayoutBaseProps> = ({ LeftElement = null, RightElement = null, children, user, latestDocPrivacy }: LayoutBaseProps) => {

  
  let nav_bar = <NavBarEmpty/>
  if(user){
    if(user.account_type === 'BENEFICIARIO'){
      nav_bar = <NavBarBeneficiario /> 
    } else if(user.account_type === 'REGIONALE'){
      nav_bar = <NavBar/>
    } else if (user.account_type === 'CAA' ){
      nav_bar =<NavBarCaa />
    } else if ( user.account_type === 'AT' ){
      nav_bar =<NavBarAT />
    }
  }

  return (
    <Box display="flex" flexDirection="column" minH="100vh">
      {nav_bar} 
      <Box w="100%" p="10" flex="1 1 auto">
        {/* {transition.state === 'loading' && transition.type === 'normalLoad' ? */}
        {/* <Box
            background={"rgba(255,255,255,0.7)"}
            position={'absolute'}
            width={'100%'}
            height={'100%'}
            zIndex={999}
          > */}
        {/* <Center height={'50%'}> */}
        {/* <Spinner
              thickness='4px'
              speed='0.65s'
              emptyColor='gray.200'
              color='blue.500'
              size='xl'
            />
            </Center>
          </Box>
          : null} */}

        {children}

      </Box>
      <Box w="100%">
        <SiarcFooter latestPrivacyFileKey={latestDocPrivacy || ""} />
      </Box>
      
    </Box>
  );
};

export default LayoutBase;
